import { useBasket } from '@/src/packages/components/contexts/basket.context';
import { useBundleContext } from '@/src/packages/components/pages/Bundle/BundleContext';
import { BundleOption } from '@/src/packages/components/pages/Bundle/BundleOption';
import { Box } from '@/src/packages/components/ui/Box';
import { Button } from '@/src/packages/components/ui/Button';
import { Stack } from '@/src/packages/components/ui/Stack';
import Image from 'next/image';
import { IFetchBundleSchema } from '@bitmap/contracts';
import { sortBy } from 'lodash';
import { useSizeGuideDrawerStore } from '@/src/packages/hooks/use-basket-drawer';
import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetFooter,
  SheetHeader,
} from '@/src/packages/components/ui/Sheet';

const BundleProductListItem = ({
  variant,
}: {
  variant: IFetchBundleSchema['variants'][0];
}) => {
  const { handleOpen } = useSizeGuideDrawerStore();

  return (
    <Box className="flex gap-4" key={variant.id}>
      <Box className="w-[100px] lg:w-[150px]">
        <Box className="relative aspect-square border">
          <Image src={variant.images[0].fields.file.url} alt="" fill />
        </Box>
      </Box>
      <Box key={1} className="flex flex-1 flex-col">
        <Box className="mb-4 flex leading-none">
          <Box className="text-lg font-medium">{variant.product.title}</Box>
        </Box>

        <Box className="w-full">
          {variant.product.options.length > 0 ? (
            variant.product.options.map((option) => {
              return (
                <Box key={1} className="space-y-2">
                  <Box className="flex">
                    <Box className="leading-none">{option.name}</Box>

                    <Box
                      as="button"
                      onClick={handleOpen}
                      className="text-text-secondary hover:text-text-primary ml-auto leading-none"
                    >
                      Size guide
                    </Box>
                  </Box>
                  <BundleOption productVariant={variant} option={option} />
                </Box>
              );
            })
          ) : (
            <Box className="opacity-60">One size</Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export const BundleProductList = () => {
  const { bundle } = useBundleContext();

  return (
    <Stack spaceY={4}>
      {sortBy(bundle.variants, (variant) => variant.product.options.length > 0)
        .reverse()
        .map((variant) => {
          return <BundleProductListItem key={variant.id} variant={variant} />;
        })}
    </Stack>
  );
};

export const BundleModal = () => {
  const { isModalOpen, handleAddToBag, isValid, handleCloseModal, bundle } =
    useBundleContext();

  const { isUpdating } = useBasket();

  return (
    <Sheet open={isModalOpen} onOpenChange={handleCloseModal}>
      <SheetContent side="right" onInteractOutside={(e) => e.preventDefault()}>
        <SheetHeader title="Select options" />
        <SheetBody>
          <BundleProductList />
        </SheetBody>
        <SheetFooter>
          <Button
            onClick={handleAddToBag}
            isBlock
            size="lg"
            color="black"
            variant="solid"
            isLoading={isUpdating}
            isDisabled={!isValid}
            className="order-1 lg:order-2"
          >
            Add {bundle.variants.length} items to bag
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};
